/// <amd-module name="CodeCoverage/CodeCoverageSignalR/CodeCoverageHubProxies" />
import { jqueryShimmed } from "VSS/Features/SignalR/3rdParty/jquery.shimmed";
import { ISignalRHubProxy } from "VSS/Features/SignalR/HubProxies.types";

export namespace HubNames {
    export const codeCoverageHub = "codeCoverageHub";
}

export interface ICodeCoverageSignalRHubServer {
    watchBuild: (buildId: number) => Promise<void>;
    unwatchBuild: (buildId: number) => Promise<void>;
}

export interface ICodeCoverageSignalRHubClient {
    codeCoverageStatsChangedForBuild: (buildId: number) => void;
}

export function getCodeCoverageSignalRHubProxyToRegister<C, S>(baseProxy: ISignalRHubProxy<any, any>): ISignalRHubProxy<C, S> {
    const $ = jqueryShimmed;
    baseProxy.server = {
        watchBuild: function (buildId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["watchBuild"], $.makeArray(arguments)));
        },

        unwatchBuild: function (buildId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["unWatchBuild"], $.makeArray(arguments)));
        }
    };

    return baseProxy;
}
